import { render, staticRenderFns } from "./yeGive.vue?vue&type=template&id=10dacf64&scoped=true"
import script from "./yeGive.vue?vue&type=script&lang=js"
export * from "./yeGive.vue?vue&type=script&lang=js"
import style0 from "./yeGive.vue?vue&type=style&index=0&id=10dacf64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dacf64",
  null
  
)

export default component.exports